var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "side-menu-group",
    class: {
      'active': _vm.isRouteActive(_vm.menu)
    }
  }, [_vm._v(" " + _vm._s(_vm.menu.title) + " "), _vm._l(_vm.menu.subMenus, function (eachSubMenu) {
    return [_c('sub-side-menu-entity', {
      key: eachSubMenu.name,
      attrs: {
        "menu": eachSubMenu,
        "collapse-state": _vm.collapseState
      },
      on: {
        "on-menu-close": function ($event) {
          return _vm.onMenuClose();
        }
      }
    })];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }